
import { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_LINE_TYPE_INTELLIGENCE } from '../../../../../utils/GraphQLAPI'
import EmailTpvReport from "../../../../sharedComponent/emailTpvReport/emailTpvReport"
import ContactIntelligenceForReport from "../../../../sharedComponent/ContactReport/contactIntelligence"
import { formatPhoneNumber } from '../../../../../utils/helper'
import ai from "../../../../../_metronic/images/Ai.svg"


const ContactIntelligence = ({ data }: { data: any }) => {
    const [emailValidationResult, setEmailValidationResult] = useState<any>(null)
    const [phoneValidationResult, setPhoneValidationResult] = useState<any>(null)
    const [formatPhoneValidation, setFormatPhoneValidation] = useState<any>(null);

    const [checkPhoneLineType] = useLazyQuery(GET_LINE_TYPE_INTELLIGENCE, {
        onCompleted: (LineTypeIntelligence) => {
            setPhoneValidationResult(LineTypeIntelligence)
        },
    })

    useEffect(() => {
        const phone = data?.primaryPhoneNumber?.trim();
        if (!phone) return;
        checkPhoneLineType({
            variables: {
                phoneNumber: phone,
            },
        });
    }, [data?.primaryPhoneNumber]);//eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const emailValidationData = {
            verdict: data?.emailVerdict,
            score: data?.emailScore,
            is_suspected_disposable_address: data?.emailSuspected,
            has_suspected_bounces: Math.round(data?.emailScore * 100) <= 50 ? true : false,
            email: data?.emailId
        }
        setEmailValidationResult(emailValidationData)

    }, [data?.emailScore, data?.emailId])//eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setFormatPhoneValidation({
            phone: phoneValidationResult?.getLineTypeIntelligence?.phoneNumber
                ? formatPhoneNumber(phoneValidationResult.getLineTypeIntelligence?.phoneNumber)
                : "",
            lineType: phoneValidationResult?.getLineTypeIntelligence?.type,
            riskLevel: phoneValidationResult?.getLineTypeIntelligence?.riskLevel,
            status: phoneValidationResult?.getLineTypeIntelligence?.status,
            carrierNote: phoneValidationResult?.getLineTypeIntelligence?.carrierName
        });
    }, [phoneValidationResult?.getLineTypeIntelligence?.phoneNumber]);//eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div>
            <div>
                <h3>Contact Intelligence</h3>
                <p className='fw-semibold'><span><img
                    src={ai}
                    alt="ai-icon"
                    className='ai-icon'
                /></span>Al-powered analysis of phone and email to assess risk and deliverability</p>
            </div>
            <div className='d-flex gap-3 align-items-stretch'>
                {emailValidationResult?.verdict !== null && (
                    <div className='w-100 d-flex flex-column'>
                        <EmailTpvReport emailValidationResult={emailValidationResult} />
                    </div>
                )}
                {formatPhoneValidation && (
                    <div className='w-100 d-flex flex-column'>
                        <ContactIntelligenceForReport data={formatPhoneValidation} />
                    </div>
                )}
            </div>
        </div>

    )
}
export default ContactIntelligence;